export enum TabType {
    DRAFT = 'DRAFT',
    UNPAID = 'UNPAID',
    PAID = 'PAID',
    OVERDUE = 'OVERDUE',
    READY_TO_INVOICE = 'READY_TO_INVOICE'
}
